import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { settingsActions } from "./settings.actions";
import { exhaustMap, map } from "rxjs";
import { Settings } from "../../models/settings.model";
import { environment } from "../../../environments/environment";

@Injectable()
export class SettingsEffects {
    private httpClient = inject(HttpClient);
    private actions$ = inject(Actions);

    get$ = createEffect(() =>
        this.actions$.pipe(
            ofType(settingsActions.getSettings),
            exhaustMap(() => {
                const req = this.httpClient.get<Settings>(`${environment.api}/settings/all`);

                return req.pipe(
                    map((payload) => settingsActions.getSettingsSuccess({payload}))
                )
            })
        )
    )
}